'use strict';

// http://eonasdan.github.io/bootstrap-datetimepicker/

wbApp.directive('wbDateTimePicker', ['$timeout',
    function ($timeout) {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                ngModel: '=',
                placeholder: '@'
            },
            template: 
                '<div class="input-group date">' +
                    '<input type="text" class="form-control" data-format="D.M.YYYY HH:mm" placeholder="{{placeholder}}"/>' +
                    '<span class="input-group-addon"><span class="fa fa-calendar"></span>' +
                    '</span>' +
                '</div>',
            replace: true,
            link: function (scope, elm, attrs, controller) {
                $timeout(function () {
                    $(elm).datetimepicker({
                        pickDate: true,                 //en/disables the date picker
                        pickTime: true,                 //en/disables the time picker
                        useMinutes: true,               //en/disables the minutes picker
                        useSeconds: false,              //en/disables the seconds picker
                        minuteStepping: 15,               //set the minute stepping
                       // startDate: 1 / 1 / 1970,             //set a minimum date
                        //endDate: (today +50 years),   //set a maximum date
                        language: 'cs',                  //sets language locale
                        defaultDate: "",                 //sets a default date, accepts js dates, strings and moment objects
                        disabledDates: [],               //an array of dates that cannot be selected
                        //enabledDates:1/1/1970,        //an array of dates that can be selected
                        icons: {
                            time: "fa fa-clock-o",
                            date: "fa fa-calendar",
                            up: "fa fa-arrow-up",
                            down: "fa fa-arrow-down"
                        }
                    });

                    scope.$watch('ngModel', function (newValue) {
                        var picker = $(elm).data("DateTimePicker");
                        if (picker) {
                            var date = picker.getDate();
                            if (newValue !== date) {
                                picker.setDate(newValue);
                            }
                        }
                    });

                    $(elm).on("change.dp", function (e) {

                        var inputVal = $(elm).find('input').val();

                        if (e.date !== undefined) {
                            if (!inputVal) {
                                scope.ngModel = null;
                            } else {
                                if (scope.ngModel !== e.date) {
                                    scope.ngModel = e.date;
                                }
                            }
                            scope.$apply();
                        }
                    });

                }, 1);
            }
        }
    }
]);
